export default __webpack_public_path__ + "static/media/dog-2.2795784a.png";